<template>
    <q-page>
        <div class="q-display-2">Użytkownicy aplikacji</div>

        <q-table
            title="Użytkownicy"
            :data="users"
            :columns="columns"
            row-key="userId"
            :loading="loading"
            :rows-per-page-options="[20, 100, 0]"
            :pagination.sync="paginationControl"
        >
            <q-td slot="body-cell-options" slot-scope="props" :props="props">
                <q-btn
                    v-if="! ongoing[`trainer-${props.row.userId}`]"
                    round
                    flat
                    icon="chat"
                    @click="giveTrainerRights(props.row)">
                    <q-tooltip>
                        Ustaw jako trenera
                    </q-tooltip>
                </q-btn>
                <q-btn
                    v-else
                    round
                    flat
                    icon="cached"
                    class="animate-spin">
                </q-btn>

                <q-btn
                    v-if="! ongoing[`locking-${props.row.userId}`]"
                    round
                    flat
                    icon="lock"
                    :class="[{locked: props.row.blocked}]"
                    @click="lockOrUnlock(props.row)">
                    <q-tooltip v-if="props.row.blocked">
                        Odblokuj
                    </q-tooltip>
                    <q-tooltip v-else>
                        Zablokuj
                    </q-tooltip>
                </q-btn>
                <q-btn
                    v-else
                    round
                    flat
                    icon="cached"
                    class="animate-spin">
                </q-btn>

                <q-btn
                    v-if="! ongoing[`resetting-${props.row.userId}`]"
                    round
                    flat
                    icon="vpn_key"
                    @click="resetPassword(props.row)">
                    <q-tooltip>
                        Zresetuj hasło
                    </q-tooltip>
                </q-btn>
                <q-btn
                    v-else
                    round
                    flat
                    icon="cached"
                    class="animate-spin">
                </q-btn>

                <q-btn
                    v-if="! ongoing[`deleting-${props.row.userId}`]"
                    round
                    flat
                    icon="delete"
                    @click="deleteUser(props.row)">
                    <q-tooltip>
                        Usuń użytkownika
                    </q-tooltip>
                </q-btn>
                <q-btn
                    v-else
                    round
                    flat
                    icon="cached"
                    class="animate-spin">
                </q-btn>
            </q-td>
        </q-table>

    </q-page>
</template>

<script>
    import Item from 'quasar-framework/src/mixins/item'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCheckbox from 'quasar-framework/src/components/checkbox/QCheckbox'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'

    export default {
        name: 'ExtUsers',
        components: {QIcon, QBtn, QTooltip, QCheckbox, QCardMain, QCardTitle, QCardActions, QInput, Item},
        data () {
            return {
                ROLE_TO_NAME_MAP: {
                    'Admin': 'Admin',
                    'Redactor': 'Redaktor',
                    'Coordinator': 'Koordynator',
                },
                NAME_TO_ROLE_MAP: {
                    'Admin': 'Admin',
                    'Redactor': 'Redaktor',
                    'Coordinator': 'Koordynator',
                },
                ROLES: ['Admin', 'Redactor', 'Coordinator'],
                editDialogVisible: false,
                editableItem: undefined,
                adding: false,
                updating: false,
                items: [],
                columns: [
                    {
                        field: 'email',
                        name: 'email',
                        label: 'Email',
                        align: 'left',
                        sortable: true,
                    },
                    {
                        name: 'options',
                    },
                ],
                ongoing: {},
                paginationControl: {
                    rowsPerPage: 20,
                    page: 1
                }
            }
        },
        computed: {
            loading () {
                return this.$store.state.loadingUsers
            },
            users () {
                return this.$store.getters.extuser
            },
        },
        methods: {
            fetch () {
                this.$store.dispatch('fetchAll', {
                    what: 'extuser'
                })
            },
            editItem (model) {
                this.updating = true
                this.adding = false

                this.editDialogVisible = true

                this.editableItem = {
                    ...model,
                }
            },
            saveItem () {
                if (this.adding) {
                    this.$store.dispatch('addUser', this.editableItem).then(() => {
                        this.closeDialog()
                    }).catch(() => {
                        // do nothing - maybe show some error
                    })

                } else if (this.updating) {
                    this.$store.dispatch('updateUser', this.editableItem).then(() => {
                        this.closeDialog()
                    }).catch(() => {
                        // do nothing - maybe show some error
                    })
                }
            },
            closeDialog () {
                this.editableItem = undefined
                this.editDialogVisible = false

                this.adding = false
                this.updating = false
            },
            lockOrUnlock (model) {
                if (model.blocked) {
                    this.$q.dialog({
                        title: 'Czy na pewno odblokować?',
                        cancel: true,
                    }).then(() => {
                        this.$set(this.ongoing, `locking-${model.userId}`, true)
                        this.$store.dispatch('unlockExtuser', {
                            userId: model.userId,
                        }).then(() => {
                            this.ongoing[`locking-${model.userId}`] = false

                        }).catch(() => {
                            this.ongoing[`locking-${model.userId}`] = false
                        })
                    })
                } else {
                    this.$q.dialog({
                        title: 'Podaj powód blokady użytkownika',
                        prompt: {
                            model: '',
                            type: 'text',
                        },
                        cancel: true,
                    }).then((reason) => {
                        this.$set(this.ongoing, `locking-${model.userId}`, true)
                        this.$store.dispatch('lockExtuser', {
                            userId: model.userId,
                            reason,
                        }).then(() => {
                            this.ongoing[`locking-${model.userId}`] = false

                        }).catch(() => {
                            this.ongoing[`locking-${model.userId}`] = false
                        })
                    })
                }
            },
            resetPassword (model) {
                this.$q.dialog({
                    title: 'Czy na pewno zresetować hasło?',
                    cancel: true,
                }).then(() => {
                    this.$set(this.ongoing, `resetting-${model.userId}`, true)
                    return this.$store.dispatch('resetExtuserPassword', model.userId)
                    .then(() => {
                        this.ongoing[`resetting-${model.userId}`] = false
                    }).catch(() => {
                        this.ongoing[`resetting-${model.userId}`] = false
                    })
                })
            },
            deleteUser (model) {
                this.$q.dialog({
                    title: 'Czy na pewno usunąć użytkownika?',
                    cancel: true,
                }).then(() => {
                    this.$set(this.ongoing, `deleting-${model.userId}`, true)
                    return this.$store.dispatch('remove', {
                        what: 'extuser',
                        item: model
                    })
                    .then(() => {
                        this.ongoing[`deleting-${model.userId}`] = false
                    }).catch(() => {
                        this.ongoing[`deleting-${model.userId}`] = false
                    })
                })
            },
            giveTrainerRights (model) {
                this.$set(this.ongoing, `trainer-${model.userId}`, true)
                return this.$store.dispatch('giveTrainerRights', {
                    userId: model.userId,
                }).then(() => {
                    this.ongoing[`trainer-${model.userId}`] = false
                }).catch(() => {
                    this.ongoing[`trainer-${model.userId}`] = false
                })
            },
        },
        mounted () {
            this.fetch()
        },
    }
</script>

<style lang="scss">
    .locked {
        color: red;
    }
</style>